
<div class="panel" >
  
  <div  class="panel-menu" >

    <div class="panel-menu-item"  #menuTrigger="matMenuTrigger"
      *ngFor="let item of appMenu " 
      [matMenuTriggerFor]="childMenu"
      [class.menu-opened]="layoutDataService.bSubToggleMenuPanel.value "
      [class.menu-extended]="this.extendedMenuKey ===  item.menu_key && this.layoutDataService.bSubToggleMenuPanel.value === true"
      [matMenuTriggerData]="{childItems:item.children}"
      (mouseenter)=" openChildMenu($event,menuTrigger,item)"
      (mouseleave)="closeChildMenu($event,menuTrigger,item)"
      (click)="toggleExtendedMode($event,item)"
       >

      <div class="panel-menu-item-hover"   
        [class.child-opened]="this.openedMenuKey ===  item.menu_key"
        [class.menu-opened]="layoutDataService.bSubToggleMenuPanel.value"
        [class.menu-extended]="this.extendedMenuKey ===  item.menu_key && this.layoutDataService.bSubToggleMenuPanel.value === true"
        [class.selected-active]="selectedMenuKeyMain === item.menu_key"
        >
        <mat-icon [svgIcon]="item.icon" class="panel-menu-item-icon" ></mat-icon>

        <div class="panel-menu-item-full"  
          *ngIf="this.layoutDataService.bSubToggleMenuPanel.value" 
          [class.menu-opened]="layoutDataService.bSubToggleMenuPanel.value">

          <span class="panel-menu-item-full-title " >
            {{'MAIN_MENU.MENU_ITEMS.' +item.menu_key |translate}} 
          </span>

          <mat-icon class="panel-menu-item-full-icon"
            [svgIcon]="this.extendedMenuKey ===  item.menu_key? '' : 'arrow-right-s-line'" >
          </mat-icon>

        </div>
      </div>

      <div class="panel-menu-item extended-menu" 
      *ngIf="this.extendedMenuKey ===  item.menu_key && this.layoutDataService.bSubToggleMenuPanel.value === true">
        <button disableRipple mat-menu-item class="panel-menu-child-item" 
          *ngFor="let itemChild of item.children" 
          [class.selected-active]="itemChild?.key === selectedMenuKeyChild"
          (click)="onOpenMenuItem(itemChild,item,$event)" 
          > 
          {{'MAIN_MENU.SUBMENU_ITEMS.' + itemChild.key | translate}}
        </button>
      </div>

      <mat-menu #childMenu="matMenu"  
        [class]="'panel-menu-child' + (layoutDataService.bSubToggleMenuPanel.value? '-opened' : '')" 
        panelClass="panel-menu-child'"
        hasBackdrop="false" >

        <div (mouseenter)=" openChildMenu($event,menuTrigger,item)" (mouseleave)="closeChildMenu($event,menuTrigger,item)">
          <ng-template matMenuContent let-menuItem="menuItem">
            <button disableRipple mat-menu-item class="panel-menu-child-item" 
              *ngFor="let itemChild of menuItem.children" 
              [class.selected-active]="itemChild?.key === selectedMenuKeyChild"
              (click)="onOpenMenuItem(itemChild,menuItem)"> 
              {{'MAIN_MENU.SUBMENU_ITEMS.' + itemChild.key | translate}}
            </button>
          </ng-template>
        </div>

      </mat-menu>

    </div>
  </div>

  <div class="panel-slider" (click)="toggleMenuPanel()">
    <div class="panel-slider-hr-divider"></div>
    <mat-icon [svgIcon]="layoutDataService.bSubToggleMenuPanel.value? 'arrow-left-s-line' : 'arrow-right-s-line' " class="panel-slider-item-icon"></mat-icon>
  </div>

</div>